import { Language } from '../../language/language.model';
import { LanguageActions, LanguageActionTypes } from './language.actions';

export interface LanguageState {
  languages: Language[];
  loaded: boolean;
}

export const initialState: LanguageState = {
  languages: [],
  loaded: false,
};

export function languageReducer(state = initialState, action: LanguageActions): LanguageState {
  switch (action.type) {

    case LanguageActionTypes.LoadLanguagesSuccess:
      return {
        ...state,
        languages: action.payload,
        loaded: true
      };

    case LanguageActionTypes.LoadLanguagesFail:
      return {
        ...state,
        loaded: false
      };

    default:
      return state;
  }
}
